export const ORDER_RETURN_QUERY_TYPE = 'ORDERRETURN';

const RETURNABLE_ORDER_STATUSES_FOR_RETURN_FLOW = [
  'SHIPPED',
  'READY_FOR_COLLECTION',
  'COLLECTED',
] as const;

export function orderAllowsReturnInitiation(
  status: string | null | undefined,
): boolean {
  return (
    !!status &&
    (RETURNABLE_ORDER_STATUSES_FOR_RETURN_FLOW as readonly string[]).includes(
      status,
    )
  );
}
